export const RESEND_EMAIL_CONFIRMATION = 'AUTH/RESEND_EMAIL_CONFIRMATION';
export const RESEND_EMAIL_CONFIRMATION_PENDING = `${RESEND_EMAIL_CONFIRMATION}_PENDING`;
export const RESEND_EMAIL_CONFIRMATION_FULFILLED = `${RESEND_EMAIL_CONFIRMATION}_FULFILLED`;
export const RESEND_EMAIL_CONFIRMATION_REJECTED = `${RESEND_EMAIL_CONFIRMATION}_REJECTED`;

export const resendEmailConfirmation = (email) => ({
  type: RESEND_EMAIL_CONFIRMATION,
  email,
});

export const RESET = `${RESEND_EMAIL_CONFIRMATION}_RESET`;

export const reset = () => ({
  type: RESET,
});
